import { createStore, applyMiddleware } from "redux";
import { composeWithDevTools } from "redux-devtools-extension";
import { persistReducer, persistStore } from "redux-persist";
import storage from "redux-persist/lib/storage";

import createSagaMiddleware from "redux-saga";

import ducks from "./ducks";
import sagas from "./sagas";

const middlewares: any[] = [];

const sagaMiddleware = createSagaMiddleware();

middlewares.push(sagaMiddleware);

const persistConfig = {
    key: "gestaofinanceira",
    storage,
    whitelist: ["expenses"],
};

const persistedReducer = persistReducer(persistConfig, ducks);

const store = createStore(
    persistedReducer,
    composeWithDevTools(applyMiddleware(...middlewares))
);
const persistor = persistStore(store);

sagaMiddleware.run(sagas);

export { store, persistor };
